import { combineReducers } from 'redux'
import {documentSearch} from './../documentSearch/reducer';
import {categories} from "../subscription/reducer";
import {modal} from "../ui/modal/reducer";
import {error} from "../error/reducer";
import {userDetails} from "../user/reducer";


export default combineReducers({
  userDetails, documentSearch, categories, modal, error
})